export default __webpack_public_path__ + "static/media/act-to.8f869f18.svg";